<div class="sheet-header">
  <button (click)="bottomSheetRef.dismiss()" mat-mini-fab color="warn">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div [innerHTML]="safeHtmlContent"></div>
